import { render, staticRenderFns } from "./TablePessoaProcesso.vue?vue&type=template&id=609a6c26&scoped=true"
import script from "./TablePessoaProcesso.vue?vue&type=script&lang=js"
export * from "./TablePessoaProcesso.vue?vue&type=script&lang=js"
import style0 from "./TablePessoaProcesso.vue?vue&type=style&index=0&id=609a6c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a6c26",
  null
  
)

export default component.exports